export const ONGLET_EMPLOYEUR = 'Employeur' as const
export const ONGLET_FORMATION = 'Formation' as const
